import React, { useRef, useState } from 'react';

import ReactDOM from 'react-dom';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';

import { ENUM_ROLE_USER, ENUM_STEP_PROFILE } from 'constants/enum';
import UpdateEmail from 'pages/Profile/Form/UpdateEmail';
import UpdateFacility from 'pages/Profile/Form/UpdateFacility';
import UpdateName from 'pages/Profile/Form/UpdateName';
import UpdatePassword from 'pages/Profile/Form/UpdatePassword';
import UpdateProfile from 'pages/Profile/Form/UpdateProfile';
import { clearModalProfile } from 'store/actions/profile';

const Profile = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const modalProfileRef = useRef(null);
  const { me } = useSelector((state) => state.auth);
  const [action, setAction] = useState(ENUM_STEP_PROFILE.PROFILE);

  const closeModal = () => {
    dispatch(clearModalProfile());
  };

  const clickBackdrop = () => {
    modalProfileRef.current.classList.add('animate-fade-out');
    setTimeout(() => {
      modalProfileRef.current.classList.remove('animate-fade-out');
    }, 300);
  };

  return ReactDOM.createPortal(
    <div id="modal" className="fixed inset-0 flex-middle-center bg-gray-800 bg-opacity-50 z-50">
      <div onClick={clickBackdrop} className="fixed inset-0 backdrop" />

      <div ref={modalProfileRef} className="bg-white rounded-sm shadow-lg relative w-120 modal-content">
        {action === ENUM_STEP_PROFILE.PROFILE && (
          <>
            <div className="flex-between-center px-6 py-4 border-b border-white-720">
              <p className="font-bold">{t('TITLE_PROFILE')}</p>
              <div onClick={closeModal}>
                <img className="cursor-pointer" src={require('assets/resources/Close.svg').default} alt="close" width={16} height={16} />
              </div>
            </div>

            <div className="p-6">
              <fieldset>
                <div className="pb-3 mb-4 flex-between-center border-b border-white-720 gap-2">
                  <div>
                    <p className="font-bold text-sm mb-2">{t('FULL_NAME')}</p>
                    <p className="text-black/85 break-all line-clamp-1" dangerouslySetInnerHTML={{ __html: me?.name || '&nbsp;' }}></p>
                  </div>
                  <p
                    className="text-sm underline text-primary-346 cursor-pointer whitespace-nowrap"
                    onClick={() => setAction(ENUM_STEP_PROFILE.UPDATE_NAME)}
                  >
                    {t('EDIT')}
                  </p>
                </div>
              </fieldset>

              <fieldset>
                <div className="pb-3 mb-4 flex-between-center border-b border-white-720 gap-2">
                  <div>
                    <p className="font-bold text-sm mb-2">{t('EMAIL_ADDRESS')}</p>
                    <p className="text-black/85 break-all line-clamp-1">{me?.email}</p>
                  </div>
                  <p
                    className="text-sm underline text-primary-346 cursor-pointer whitespace-nowrap"
                    onClick={() => setAction(ENUM_STEP_PROFILE.UPDATE_EMAIL)}
                  >
                    {t('EDIT')}
                  </p>
                </div>
              </fieldset>

              <fieldset>
                <div className="pb-3 mb-4 flex-between-center border-b border-white-720 gap-2">
                  <div>
                    <p className="font-bold text-sm mb-2">{t('PASSWORD')}</p>
                    <p className="text-black/85">{t('PASSWORD_REVIEW')}</p>
                  </div>
                  <p
                    className="text-sm underline text-primary-346 cursor-pointer whitespace-nowrap"
                    onClick={() => setAction(ENUM_STEP_PROFILE.UPDATE_PASSWORD)}
                  >
                    {t('EDIT')}
                  </p>
                </div>
              </fieldset>

              <fieldset>
                <div className="pb-3 flex-between-center gap-2">
                  <div>
                    <p className="font-bold text-sm mb-2">{t('FACILITY_NAME')}</p>
                    <p className="text-black/85">{me?.facility?.name}</p>
                  </div>
                  <p
                    className="text-sm underline text-primary-346 cursor-pointer whitespace-nowrap"
                    onClick={() => setAction(ENUM_STEP_PROFILE.UPDATE_FACILITY)}
                  >
                    {t('EDIT')}
                  </p>
                </div>
              </fieldset>

              {/* <fieldset>
                <div className="flex-between-center gap-2">
                  <div>
                    <p className="font-bold text-sm mb-2">{t('DEFAULT_LANGUAGE')}</p>
                    <p className="text-black/85 break-all line-clamp-1">
                      {currentLanguage === ENUM_LANGUAGE_TEXT.JAPANESE
                        ? t(ENUM_LANGUAGE.JAPANESE)
                        : currentLanguage === ENUM_LANGUAGE_TEXT.VIETNAMESE
                          ? t(ENUM_LANGUAGE.VIETNAMESE)
                          : t(ENUM_LANGUAGE.ENGLISH)}
                    </p>
                  </div>
                  <p
                    className="text-sm underline text-primary-346 cursor-pointer whitespace-nowrap"
                    onClick={() => setAction(ENUM_STEP_PROFILE.UPDATE_LANGUAGE)}
                  >
                    {t('EDIT')}
                  </p>
                </div>
              </fieldset> */}
            </div>
            {me?.role === ENUM_ROLE_USER.ADMIN && <div className="h-13 border-t border-white-720"></div>}
          </>
        )}
        {action === ENUM_STEP_PROFILE.UPDATE_EMAIL && <UpdateEmail back={() => setAction(ENUM_STEP_PROFILE.PROFILE)} />}
        {action === ENUM_STEP_PROFILE.UPDATE_PASSWORD && <UpdatePassword back={() => setAction(ENUM_STEP_PROFILE.PROFILE)} />}
        {action === ENUM_STEP_PROFILE.UPDATE_NAME && <UpdateName back={() => setAction(ENUM_STEP_PROFILE.PROFILE)} />}
        {/* {action === ENUM_STEP_PROFILE.UPDATE_LANGUAGE && <UpdateLanguage back={() => setAction(ENUM_STEP_PROFILE.PROFILE)} />} */}
        {action === ENUM_STEP_PROFILE.UPDATE_PROFILE && <UpdateProfile back={() => setAction(ENUM_STEP_PROFILE.PROFILE)} />}
        {action === ENUM_STEP_PROFILE.UPDATE_FACILITY && <UpdateFacility back={() => setAction(ENUM_STEP_PROFILE.PROFILE)} />}
      </div>
    </div>,
    document.body
  );
};

export default React.memo(Profile);
